import React from 'react';
import { Button } from './Button';
export function PurchaseSection() {
  return <section id="compra" className="py-10 px-4 bg-brand-dark scroll-mt-4" data-id="element-123">
      <div className="max-w-xl mx-auto" data-id="element-124">
        <div className="bg-brand-card rounded-md border-2 border-brand-accent p-6 text-center" data-id="element-125">
          <h2 className="text-xl font-black text-brand-accent mb-4" data-id="element-126">
            🎁 RESUMEN DE TU OFERTA (ACCESO INMEDIATO)
          </h2>
          <p className="text-sm text-gray-300 mb-6" data-id="element-127">
            Lidera tu clase con el arsenal docente más completo del mercado:
          </p>

          <ul className="text-left space-y-3 mb-8 text-sm text-white" data-id="element-128">
            <li className="flex items-start" data-id="element-129">
              <span className="text-brand-accent mr-2" data-id="element-130">✅</span>
              <span data-id="element-131">
                <strong data-id="element-132">6 Tomos Maestros:</strong> El programa completo de
                Instalaciones Eléctricas.
              </span>
            </li>
            <li className="flex items-start" data-id="element-133">
              <span className="text-brand-accent mr-2" data-id="element-134">✅</span>
              <span data-id="element-135">
                <strong data-id="element-136">3 Proyectos Integradores:</strong> Vivienda, Comercio e
                Industria (Obra real).
              </span>
            </li>
            <li className="flex items-start" data-id="element-137">
              <span className="text-brand-accent mr-2" data-id="element-138">✅</span>
              <span data-id="element-139">
                <strong data-id="element-140">Banco de Problemas:</strong> 100 ejercicios de cálculo
                con soluciones.
              </span>
            </li>
            <li className="flex items-start" data-id="element-141">
              <span className="text-brand-accent mr-2" data-id="element-142">✅</span>
              <span data-id="element-143">
                <strong data-id="element-144">Kit de Evaluación:</strong> Rúbricas y exámenes listos
                para imprimir.
              </span>
            </li>
            <li className="flex items-start" data-id="element-145">
              <span className="text-brand-accent mr-2" data-id="element-146">✅</span>
              <span data-id="element-147">
                <strong data-id="element-148">Simbología e Instrumentación:</strong> Láminas técnicas
                bajo norma IEC.
              </span>
            </li>
          </ul>

          <div className="mb-6" data-id="element-149">
            <p className="text-sm text-gray-400 line-through mb-1" data-id="element-150">
              VALOR TOTAL: $115 USD
            </p>
            <p className="text-3xl font-black text-white mb-2" data-id="element-151">
              PRECIO HOY: $19.90 USD
            </p>
            <p className="text-xs text-brand-accent font-bold" data-id="element-152">
              (Se paga en tu moneda local al cambio actual)
            </p>
          </div>

          <Button href="https://electrotecnia.impultienda.ar/checkout" className="w-full py-4 text-lg mb-4" data-id="element-153">
            ⚡ ¡SÍ! QUIERO EL KIT COMPLETO
          </Button>

          <div className="text-xs text-gray-400 space-y-2" data-id="element-154">
            <p data-id="element-155">Garantía 7 días | Pago 100% Seguro | Acceso Instantáneo</p>
            <p className="leading-relaxed" data-id="element-156">
              Al realizar el pago, el sistema convertirá automáticamente el
              valor a tu moneda local (Pesos Mexicanos, Colombianos, Chilenos,
              etc.) según el cambio del día. Sin costos ocultos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}